import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-primary text-white mt-auto relative overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-secondary rounded-xl flex items-center justify-center mr-4 shadow-lg">
                <svg className="w-8 h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
                </svg>
              </div>
              <div>
                <h2 className="text-2xl font-bold gradient-text">IKappal East Africa Ltd</h2>
                <p className="text-sm text-gray-300">Safety & Laboratory Solutions</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              Your trusted partner for premium laboratory, industrial, and safety equipment across East Africa. 
              Committed to excellence and safety in every product we deliver.
            </p>
            <div className="space-y-3 text-sm text-gray-300">
              <div className="flex items-start">
                <svg className="w-5 h-5 mr-3 text-secondary mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <div>
                  <div className="font-semibold text-white">IKAPPAL EAST AFRICA LIMITED</div>
                  <div>P.O. Box 12995-00200, Nairobi</div>
                  <div>Britam Towers, 24th Floor, Suite 2408</div>
                </div>
              </div>
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-3 text-secondary" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <a href="mailto:ikappal@ikappal.com" className="hover:text-secondary transition-colors">
                  ikappal@ikappal.com
                </a>
              </div>
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-3 text-secondary" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <a href="tel:+254710140890" className="hover:text-secondary transition-colors">
                  +254 710 140 890
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-white transition">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Product Categories */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Categories</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/category/Eye Protection/high" className="text-gray-300 hover:text-white transition">
                  Eye Protection
                </Link>
              </li>
              <li>
                <Link to="/category/Hand Protection/high" className="text-gray-300 hover:text-white transition">
                  Hand Protection
                </Link>
              </li>
              <li>
                <Link to="/category/Respiratory Protection/high" className="text-gray-300 hover:text-white transition">
                  Respiratory Protection
                </Link>
              </li>
              <li>
                <Link to="/category/Chemical Suits/high" className="text-gray-300 hover:text-white transition">
                  Chemical Suits
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li className="text-gray-300">
                <i className="fas fa-phone mr-2"></i>+254 710 140 890
              </li>
              <li className="text-gray-300">
                <i className="fas fa-envelope mr-2"></i>ikappal@ikappal.com
              </li>
              <li className="flex space-x-4 mt-4">
                <a href="https://facebook.com" className="text-gray-300 hover:text-white transition">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://twitter.com" className="text-gray-300 hover:text-white transition">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="https://linkedin.com" className="text-gray-300 hover:text-white transition">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="https://instagram.com" className="text-gray-300 hover:text-white transition">
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} IKappal East Africa Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
